import React, { useState } from "react";

import { Example, Compare } from "../../example";
import { NumberGroups } from "./component";

export default function NumberGroupsExample() {
  return (
    <Example
      title="Number groups"
      desc={
        <>
          <p>
            Help users recognize what they type to reduce faults. Display custom
            elements using full power of HTML and CSS.
          </p>
        </>
      }
      filepath="/src/examples/NumberGroups/component.js"
      demo={Demo}
    />
  );
}

function Demo() {
  const [value, setValue] = useState("10000000");

  return (
    <Compare>
      <Compare.Group title={<code>{"<input>"}</code>}>
        <label>
          <span className="exampleBlock-label">Salary</span>
          <input
            className="regularInput"
            value={value}
            onChange={e => {
              setValue(e.target.value);
            }}
          />
        </label>
      </Compare.Group>
      <Compare.Group title={<code>{"<MightyInput>"}</code>}>
        <label>
          <span className="exampleBlock-label">Salary</span>
          <NumberGroups value={value} onUpdate={next => setValue(next)} />
        </label>
      </Compare.Group>
    </Compare>
  );
}
